const goodsTypeList = [
    {
        value: 1,
        label: '培训商品'
    },
    {
        value: 2,
        label: '培训分销商品'
    },
    {
        value: 3,
        label: '实物商品'
    },
    {
        value: 5, // 组合商品显示 标签显示实物商品
        label: '实物商品'
    },
]
const orderStatusList = [
    {
        value: '',
        label: '全部订单'
    },
    {
        value: 0,
        label: '待付款'
    },
    {
        value: 2,
        label: '已完成'
    },
    {
        value: 9,
        label: '已关闭'
    }
]
const payStatusList = [
    {
        value: 0,
        label: '待支付'
    },
    {
        value: 2,
        label: '已完成'
    },
    {
        value: 8,
        label: '已关闭'
    },
    {
        value: 9,
        label: '已关闭'
    },
]
const orderStatusText = {
    //订单状态
    0:{
        label: '待支付',
        icon: '2',
        value: 0,
    },
    
    8:{
        label: '已关闭',
        tips: '订单已取消',
        icon: '3',
        value: 8
    },
    9:{
        label: '已关闭',
        tips: '订单超时',
        icon: '3',
        value: 9
    },
}

const deliveryStatusText = {
    // 物流状态
    3:{
        value: 3,
        label: '待发货',
        tips: '买家已付款',
        icon: '2',
    },
    4:{
        value: 4,
        label: '商家已发货',
        icon: '1',
    },
    5:{
        label: '交易完成',
        tips: '交易成功',
        icon: '4',
        value: 5,
    },
}



const orderGoodsTypeList = [
    {
        value: 1,
        label: '培训商品'
    },
    {
        value: 3,
        label: '实物商品'
    },
    {
        value: 5,
        label: '组合商品'
    },
]

const entityOrderStatusList = [
    {
        value: '',
        label: '全部订单'
    },
    {
        value: 0,
        label: '待付款'
    },
    {
        value: 3,
        label: '待发货'
    },
    {
        value: 4,
        label: '已发货'
    },
    {
        value: 2,
        label: '已完成'
    },
    {
        value: 9,
        label: '已关闭'
    },
]


const orderTypeList = {
    h5: '2',
    wechat: '2',
    android: '3',
    ios: '4',
}


export {
    goodsTypeList,
    orderStatusList,
    payStatusList,
    orderStatusText,
    deliveryStatusText,
    orderTypeList,

    orderGoodsTypeList,
    entityOrderStatusList,
}